import {
  type ActiveAntePostBasedMyBetPart,
  type ActiveEventBasedMyBetPart,
  type ActiveMeetingBasedMyBetPart,
  type MyBet,
  ResultType
} from '@ps/web-sports-api-types';

import type { SelectionWithTracking } from '@swf/core/models/sports/betSlip/types';

import { convertBetLegTypeToLegType } from './convertBetLegToLeg';
import { getIsFutureOrInPlay } from './getFutureOrInPlayLeg';

export function getValidSelections(bet: MyBet): SelectionWithTracking[] {
  if (bet.result === ResultType.VOID || bet.status === 'UNAVAILABLE') {
    return [];
  }
  return bet.legs.flatMap((leg) => {
    const legType = convertBetLegTypeToLegType(leg.legType);
    const betDetails = leg.parts[0] as
      | ActiveEventBasedMyBetPart
      | ActiveMeetingBasedMyBetPart
      | ActiveAntePostBasedMyBetPart;
    const { eventId, eventTypeId, marketId, selectionId, startTime, inPlay, odds } = betDetails;
    if (
      !odds ||
      !odds.americanDisplayOdds ||
      !odds.decimalDisplayOdds ||
      !odds.fractionalDisplayOdds
    ) {
      return [];
    }
    if (getIsFutureOrInPlay(inPlay, startTime) && selectionId && marketId) {
      return {
        selectionId,
        marketId,
        eventId: Number(eventId),
        legType,
        startTime: startTime ?? '',
        eventTypeId
      };
    }
    return [];
  });
}
